import { useFlowQuery } from '@twisto/api-graphql'
import { CircleLoader } from '@twisto/components/atoms/circle-loader'
import { Flex } from '@twisto/components/atoms/flex'
import {
  Headline,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { styleUtils } from '@twisto/styles'

import { useFlow } from '../../flow/flow.context'

const POLL_INTERVAL = 1000

export const ProcessingStep = () => {
  const { sessionId, flow } = useFlow<'ProcessingStep'>()
  useFlowQuery({
    variables: {
      auth: {
        sessionId,
      },
    },
    pollInterval: POLL_INTERVAL,
    fetchPolicy: 'network-only',
  })

  const { heading, textParagraphs } = flow.currentStep

  return (
    <Flex fullHeight alignItems="center" direction="column" justify="center">
      <CircleLoader css={styleUtils.margin.bottom.xl} />
      <Headline>
        <HeadlineTitle>{heading}</HeadlineTitle>
        {textParagraphs.map((text, index) => (
          <HeadlineSubtitle key={index}>{text}</HeadlineSubtitle>
        ))}
      </Headline>
    </Flex>
  )
}
